"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/no-extraneous-dependencies
var showroom_tooltip_1 = __importDefault(require("@carvana/showroom-tooltip"));
var react_1 = __importDefault(require("react"));
var constants_1 = require("../constants");
var Tags_styles_1 = require("../Tags.styles");
var OnHoldTag = function () { return (react_1.default.createElement(showroom_tooltip_1.default, { direction: "bottom-start", display: {
        width: 212
    }, content: react_1.default.createElement("div", { className: "t-body-s text-grey-2" }, "Another customer recently began the process to purchase this vehicle, so we\u2019re holding it for them temporarily, just like we will for you. Frequently, customers do not move forward during this hold time and the vehicle becomes available again."), title: "This Vehicle Is On Hold" },
    react_1.default.createElement("div", { "data-analytics-id": "On Hold Tooltip", onClick: function (e) { return e.preventDefault(); }, className: "pointer-events-auto" },
        react_1.default.createElement(Tags_styles_1.StatusTagWrapper, { className: constants_1.tagColorMap.hold, "data-qa": "on-hold-badge" }, "On Hold")))); };
exports.default = OnHoldTag;
//# sourceMappingURL=OnHoldTag.js.map